class Messaging {
    constructor(params) {
        this.origin = '*';
        const { target = window.parent } = params || {};
        this.target = target;
    }
    sendMessage(type, data) {
        const event = { type };
        if (data)
            event.payload = data;
        this.target.postMessage(event, this.origin);
    }
}
export const messaging = new Messaging();
